const BASEURL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Authenticates a user with the backend API
 * @param {Object} credentials - User credentials (email and password)
 * @returns {Promise<Object>} - User data and token if successful
 */




export const loginUser = async (credentials) => {
  try {
    const response = await fetch(`${BASEURL}/utilisateur/loginweb`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      // Try to get more detailed error from response if available
      let errorMessage = 'Authentication failed';
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch (e) {
        // If JSON parsing fails, use status text
        errorMessage = response.statusText || errorMessage;
      }
      
      throw new Error(errorMessage);
    }

    const data = await response.json();
    
    // Store tokens in localStorage
    if (data.accessToken) {
      localStorage.setItem('authToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);
      
  
      // Extract user data from JWT token
      const userData = parseJwt(data.accessToken);
      
      // Store user data in localStorage
      const user = {
        id: userData.IdUser,
        isAdmin: userData.IsAdmin === "1",
        fullName: userData.FullName || "",
        phoneNumber: userData.PhoneNumber || "",
        type: userData.Type || "",
        image : userData.Image || "",
        email : userData.Email || "",
      };
      
      localStorage.setItem('userData', JSON.stringify(user));
      
      // Return user object and tokens
      return {
        user,
        accessToken: data.accessToken,
        refreshToken: data.refreshToken
      };
    } else {
      throw new Error('Invalid authentication response');
    }
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Helper function to parse JWT token
function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return {};
  }
}

/**
 * Logs out the current user by clearing authentication data
 */
export const logoutUser = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userData');
  // Remove token from any API instance headers if you're using axios
};

/**
 * Checks if the user is already authenticated
 * @returns {boolean} True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  
  try {
    // Parse the token to check expiration
    const payload = parseJwt(token);
    const currentTime = Date.now() / 1000; // Convert to seconds
    
    // Check if token is expired
    if (payload.exp && payload.exp < currentTime) {
      // Token is expired
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error checking authentication:', error);
    return false;
  }
};

/**
 * Gets the current user data from localStorage
 * @returns {Object|null} User data or null if not logged in
 */
export const getCurrentUser = () => {
  try {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

/**
 * Checks if the current user has admin role
 * @returns {boolean} True if user is admin, false otherwise
 */
// Users of this type only work on orders and products (limited admin menu).
export const CONFIRMATRICE_TYPE = 'Confirmatrice';

export const isConfirmatrice = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData'));
    return !!userData && userData.type === CONFIRMATRICE_TYPE;
  } catch {
    return false;
  }
};

export const isAdmin = () => {
  if (!isAuthenticated()) return false;
  
  try {
    const userData = JSON.parse(localStorage.getItem('userData'));
    return userData && userData.isAdmin === true;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};